import { Box, styled } from "@mui/material";

const TopMenuOffset = styled(Box)(({ theme }) => ({
  minHeight: theme.spacing(6),
}));

export default TopMenuOffset;
